module.exports = __webpack_public_path__ + "static/media/svgradiobutton_active.35ede8bc.svg";